import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20Chinese%20cultural%20elements%20with%20warm%20crimson%20and%20gold%20gradients%2C%20flowing%20ink%20wash%20style%20textures%2C%20traditional%20patterns%20subtly%20blended%20with%20modern%20minimalist%20design%2C%20soft%20atmospheric%20glow%2C%20elegant%20and%20sophisticated%20composition%2C%20no%20text%20no%20people&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="国产在线 - 精选内容平台"
        className="w-full h-full object-cover absolute inset-0"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          国产在线 · 精选内容平台
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 max-w-2xl mx-auto leading-relaxed">
          汇聚海量优质国产内容资源，高清流畅播放，无需下载即可在线观看。覆盖国产剧、国产电影、国产综艺、国产动漫、国产纪录片等多元题材，持续更新，始终精彩。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/guochan-ju"
            className="px-8 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 text-white font-medium rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}